// src/components/forms/shared/FileAttachment.jsx
// Reusable file attachment dropzone + list used across all forms.

import { UploadIcon, CloseIcon } from './FormIcons';
import styles from '../../../styles/forms/SharedForm.module.css';
import T from '../../T';

export default function FileAttachment({ attachments, onChange, onRemove }) {
  const handleFileChange = (e) => {
    if (e.target.files) {
      onChange(Array.from(e.target.files));
    }
  };

  return (
    <div className={styles.field}>
      <label className={styles.label}><T>Attachment(s)</T></label>

      <label htmlFor="file-upload" className={styles.dropzone}>
        <input
          id="file-upload"
          type="file"
          multiple
          onChange={handleFileChange}
          className={styles.fileInput}
        />
        <div className={styles.dropzoneIcon}>
          <UploadIcon />
        </div>
        <p className={styles.dropzoneText}><T>Drop files here or click to browse</T></p>
        <p className={styles.dropzoneHint}><T>PNG, JPG, PDF up to 10 MB</T></p>
      </label>

      {attachments.length > 0 && (
        <div className={styles.fileList}>
          <p className={styles.fileListLabel}><T>Attached files:</T></p>
          {attachments.map((att, i) => {
            // Support backward compatibility if it's just a File object temporarily
            const fileObj = att.file || att;
            return (
              <div key={i} className={styles.fileItem}>
                <span className={styles.fileIcon}><UploadIcon /></span>
                <span className={styles.fileName}>
                  {fileObj.name}
                  {att.isUploading && <span style={{ marginLeft: '8px', color: '#888', fontSize: '0.85em' }}>(<T>Uploading...</T>)</span>}
                  {att.error && <span style={{ marginLeft: '8px', color: 'red', fontSize: '0.85em' }}>({att.error})</span>}
                </span>
                <button
                  type="button"
                  className={styles.fileRemove}
                  onClick={() => onRemove(i)}
                  aria-label="Remove file"
                >
                  <CloseIcon />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
